import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Initialize and show the toast when it's added to the DOM
    const toast = new bootstrap.Toast(this.element)
    toast.show()
    
    // Remove the toast element from DOM after it's hidden
    this.element.addEventListener('hidden.bs.toast', () => {
      this.element.remove()
    })
  }
}